import React, { useState } from 'react';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import { CheckCircle, UserPlus } from 'lucide-react';
import { useAuth } from '../context/AuthContext';
import { authApi } from '../api/client';
import './TrackOrderPage.css';

const PASSWORD_REGEX = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[^A-Za-z0-9]).{8,}$/;

export default function ClaimAccountPage() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const { setSession } = useAuth();
  const token = params.get('token') || '';

  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState('');
  const [done, setDone] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    if (!PASSWORD_REGEX.test(password)) {
      setError('Le mot de passe doit contenir au moins 8 caractères, une majuscule, une minuscule, un chiffre et un caractère spécial.');
      return;
    }
    if (password !== confirmPassword) {
      setError('Les deux mots de passe ne correspondent pas.');
      return;
    }
    setSubmitting(true);
    try {
      const res = await authApi.claimConfirm(token, password);
      setSession(res);
      setDone(true);
      setTimeout(() => navigate('/app/orders'), 1200);
    } catch (err) {
      setError(
        err.data?.error === 'invalidToken'
          ? 'Ce lien est invalide ou a expiré. Demandez un nouveau lien depuis la page de suivi de votre commande.'
          : 'Une erreur est survenue. Veuillez réessayer.'
      );
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="track-page">
      <div className="container">
        <div className="track-card">
          <div className="track-icon">
            <UserPlus size={34} />
          </div>
          <h1>Créer mon compte</h1>
          <p className="track-lead">
            Définissez votre mot de passe pour activer votre compte.
            Vos commandes précédentes seront automatiquement rattachées à votre espace client.
          </p>

          {!token && (
            <p className="track-error" role="alert">
              Lien invalide : aucun jeton d&apos;activation n&apos;est présent. Utilisez le lien reçu par email.
            </p>
          )}

          {token && !done && (
            <form className="track-form" onSubmit={handleSubmit}>
              <label>
                Nouveau mot de passe
                <input
                  type="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  autoComplete="new-password"
                  required
                />
              </label>
              <label>
                Confirmer le mot de passe
                <input
                  type="password"
                  value={confirmPassword}
                  onChange={(e) => setConfirmPassword(e.target.value)}
                  autoComplete="new-password"
                  required
                />
              </label>
              {error && <p className="track-error" role="alert">{error}</p>}
              <button type="submit" className="btn btn-primary" disabled={submitting}>
                {submitting ? 'Activation…' : 'Activer mon compte'}
              </button>
            </form>
          )}

          {done && (
            <div className="track-result" style={{ textAlign: 'center' }}>
              <p className="track-paid" style={{ justifyContent: 'center' }}>
                <CheckCircle size={18} /> Compte créé avec succès — redirection vers vos commandes…
              </p>
              <p className="track-foot">
                <Link to="/app/orders" className="dash-link">Accéder à mes commandes</Link>
              </p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
